import { RedirectIcon } from "components/icons";
import defaultConfig from "config";

export const RequestFeatureCard = () => {
  return (
    <div className="bg-[#DBEAFE] mt-3 p-3 rounded-[6px] border-[0.5px] border-dashed border-[#2563EB] max-h-fit text-[#2563EB] md:hidden ">
      <h3 className="text-[14px] font-medium flex flex-row items-center gap-1 mb-3">
        Help us improve CanvasAI 😇
      </h3>
      <div>
        <p className="text-[12px]">
          Your feedback helps us create a better experience for you.
        </p>
        <ul className="text-[12px]  list-disc list-inside leading-[18px] mt-[6px] mb-4">
          <li>Let us know what’s not working well</li>
          <li>Share ideas to make things better</li>
        </ul>
        <a
          href={defaultConfig.canny_url}
          target="_blank"
          rel="noreferrer"
          className="bg-[#4338CA] flex flex-row items-center justify-center py-2 px-4 gap-3 font-medium  text-white rounded"
        >
          Request Feature?
          <RedirectIcon />
        </a>
      </div>
    </div>
  );
};
